import { useEffect, useRef } from 'react';
import { useI18n } from './i18n';

export default function OConstruction() {
  const { t } = useI18n();
  const svgRef = useRef(null);

  useEffect(() => {
    const svg = svgRef.current;
    if (!svg) return;

    let timer = null;

    const restartAnimation = () => {
      svg.classList.remove('os-o-animating');
      // Trigger reflow on each animated child
      const children = svg.querySelectorAll('.os-o-const, .os-o-ring, .os-o-tail, .os-o-corner, .os-o-arc, .os-o-90, .os-o-dim');
      children.forEach(el => {
        el.style.animation = 'none';
        void el.offsetWidth;
        el.style.animation = '';
      });
      svg.classList.add('os-o-animating');

      // Restart after animation completes (1.6s) + 2s pause
      clearTimeout(timer);
      timer = setTimeout(restartAnimation, 3600);
    };

    restartAnimation();

    return () => {
      clearTimeout(timer);
      svg.classList.remove('os-o-animating');
    };
  }, []);

  return (
    <svg
      ref={svgRef}
      className="os-o"
      viewBox="0 0 400 400"
      role="img"
      aria-label={t('hero.oAria')}
    >
      <defs>
        <marker id="os-arr" markerWidth="8" markerHeight="8" refX="6" refY="3" orient="auto">
          <path d="M0,0 L7,3 L0,6 z" fill="var(--blue)" />
        </marker>
        <marker id="os-arr-r" markerWidth="8" markerHeight="8" refX="1" refY="3" orient="auto">
          <path d="M7,0 L0,3 L7,6 z" fill="var(--blue)" />
        </marker>
      </defs>
      <rect className="os-o-const c1" x="40" y="40" width="320" height="320" />
      <line className="os-o-const os-o-const2 c2" x1="40" y1="40" x2="360" y2="360" />
      <line className="os-o-const os-o-const2 c3" x1="360" y1="40" x2="40" y2="360" />
      <line className="os-o-const c4" x1="188" y1="200" x2="212" y2="200" />
      <line className="os-o-const c4" x1="200" y1="188" x2="200" y2="212" />
      <g transform="rotate(20 200 200)">
        <circle className="os-o-tail" cx="200" cy="200" r="52" />
      </g>
      <g transform="rotate(125 200 200)">
        <circle className="os-o-ring" cx="200" cy="200" r="128" />
      </g>
      <path className="os-o-corner" d="M 40 66 L 40 40 L 66 40" />
      <path className="os-o-arc" d="M 66 40 A 26 26 0 0 1 40 66" />
      <text className="os-o-90" x="78" y="74">90°</text>
      <line className="os-o-const c5" x1="72" y1="368" x2="72" y2="390" />
      <line className="os-o-const c5" x1="328" y1="368" x2="328" y2="390" />
      <line className="os-o-const c6" x1="72" y1="382" x2="328" y2="382" markerStart="url(#os-arr-r)" markerEnd="url(#os-arr)" />
      <text className="os-o-dim" x="200" y="376" textAnchor="middle">Ø 256</text>
    </svg>
  );
}
